<script lang="ts">
  export let severity: "error" | "info" | "success" | "warning" = "info"
</script>

<div class="au-alert" data-severity={severity} {...$$restProps}>
  {#if $$slots.icon}
    <div class="au-alert__icon">
      <slot name="icon" />
    </div>
  {/if}
  <div class="au-alert__content-wrapper">
    <div class="au-alert__content">
      <slot />
    </div>
  </div>
</div>

<style>
  .au-alert {
    border-radius: var(--au-border-radius-sharp);
    display: flex;
    gap: var(--au-spacing-md);
    padding: var(--au-spacing-sm) var(--au-spacing-md);
    align-items: center;
    color: var(--au-text-color-default);
  }

  .au-alert[data-severity="error"] {
    background-color: var(--au-background-negative-subtle);
    --au-alert-icon-color: var(--au-text-color-negative);
  }

  .au-alert[data-severity="info"] {
    background-color: var(--au-background-neutral);
    --au-alert-icon-color: var(--au-text-color-default);
  }

  .au-alert[data-severity="success"] {
    background-color: var(--au-background-positive-subtle);
    color: var(--au-text-color-positive);
    --au-alert-icon-color: var(--au-text-color-positive);
  }

  .au-alert[data-severity="warning"] {
    background-color: var(--au-background-information-subtle);
    color: var(--au-text-color-information);
    --au-alert-icon-color: var(--au-text-color-information);
  }

  .au-alert__icon {
    display: flex;
    width: var(--au-icon-width-md);
  }

  /**
   * Make Safari behave
   * @see https://stackoverflow.com/questions/24899943/how-do-i-make-flex-box-work-in-safari#answer-59348265
   */
  .au-alert__icon :global(svg) {
    flex: 1 0 auto;
  }

  .au-alert__icon :global(svg) {
    stroke: var(--au-alert-icon-color);
    fill: var(--au-alert-icon-color);
  }

  .au-alert__content-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: var(--au-spacing-2xs);
  }

  .au-alert__content {
    font-weight: var(--au-text-weight-regular);
    font-size: var(--au-text-body-small-font-size);
    line-height: var(--au-text-body-small-line-height);
  }
</style>
